import { EnhancedVideoRotator } from '@/components/EnhancedVideoRotator';

const VideoRotator = () => {
  return <EnhancedVideoRotator />;
};

export default VideoRotator;